import { styled } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';

export const StyledTagSelect = styled(Autocomplete)({
  '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
    paddingRight: '10px !important',
  },
  '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot': {
    paddingRight: '10px !important',
  },
  '& .MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root': {
    paddingRight: '10px !important',
  },
  '& .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot': {
    paddingRight: '10px !important',
  },
  '& .MuiOutlinedInput-root': {
    padding: '7px !important',
  },
}) as typeof Autocomplete; 